
import { Component } from 'vue-property-decorator';

import RemoteDataTable, {
  RemoteDataField
} from '@/components/RemoteDataTable.vue';

import MerchantStaffAddEdit from '@/views/DashView/MerchantStaff/MerchantStaffAddEdit.vue';
import { getResponseToMTH } from '@/utils/helpers';
import constants from '@/utils/constants';

class MerchantStaffItem {
  name: string = '';
  createdAt: string = '';
  deletedAt: any = null;
  id: number = 0;
  outletCode: string = '';
  whatsApp: string = '';
  email: string = '';
  status: number = 0;
  updatedAt: string = '';
  pinCode: string = '';
}

@Component({
  components: {
    editor: MerchantStaffAddEdit
  }
})
export default class MerchantStaffList extends RemoteDataTable<
  MerchantStaffItem
  > {
  public pageTitle: string = 'Merchant Staff List';

  public newButtonText: string = 'New Merchant Staff';

  public fieldsSet: Array<RemoteDataField> = [
    new RemoteDataField({ key: 'index', label: '', sortable: false }),
    new RemoteDataField({ key: 'action', label: '', sortable: false }),
    new RemoteDataField({ key: 'outletCode', label: 'Outlet Code' }),
    new RemoteDataField({ key: 'name', label: 'Name' }),
    new RemoteDataField({ key: 'whatsApp', label: 'WhatsApp' }),
    new RemoteDataField({ key: 'status', label: 'Status' }),
    new RemoteDataField({ key: 'email', label: 'Email' }),
    new RemoteDataField({ key: 'pinCode', label: 'Pin Code' }),
  ];

  // to get page data
  get items(): MerchantStaffItem[] {
    return this.$store.getters.GetAllMerchantStaff;
  }

  get paging(): MerchantStaffItem[] {
    return this.$store.getters.PagingMerchantStaff;
  }

  get sorting(): MerchantStaffItem[] {
    return this.$store.getters.SortingMerchantStaff;
  }

  get filtering(): MerchantStaffItem[] {
    return this.$store.getters.FilteringMerchantStaff;
  }
  sortingChanged(ctx) {
    this.$store.dispatch('UpdateSortingMerchantStaff', {
      byField: ctx.sortBy,
      isDesc: ctx.sortDesc
    });
  }
  mounted() {
    if (!this.$store.state.commonUtils.isFetchingData) {
      this.reload();
    }
  }
  filterChanged(isResetFilter) {
    this.$store.dispatch('UpdateFilteringMerchantStaff', {
      isResetFilter: isResetFilter
    });
  }

  reload(id = null) {
    if (id === 1) {
      this.$store.state.merchantStaff.pagingMerchantStaff.page = 1;
    }
    this.$store.dispatch('GetAllMerchantStaff');
  }

  // delete item
  deleteItem(item) {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: constants.CONFIRM_DELETE_ITEM,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.$store
          .dispatch('DeleteMerchantStaff', item.id)
          .then(response => {
            getResponseToMTH(response, this.$swal, constants.RECORD_IS_DELETED);
          })
          .catch(error => {
            this.$swal(
              constants.SOMETHING_WROING,
              error.response.data.message,
              constants.STATUS_ERROR
            );
          });
      }
    });
  }

  setPerPage(page) {
    this.$store.state.merchantStaff.pagingMerchantStaff.size = page;
    this.$store.dispatch('GetAllMerchantStaff');
  }
}
